import { render, staticRenderFns } from "./Swipers.vue?vue&type=template&id=63cb611c&scoped=true&"
import script from "./Swipers.vue?vue&type=script&lang=js&"
export * from "./Swipers.vue?vue&type=script&lang=js&"
import style0 from "./Swipers.vue?vue&type=style&index=0&id=63cb611c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb611c",
  null
  
)

export default component.exports